import { countAndMapAssignedTasks } from "./commonUtils";
import { MemberTaskCount } from "../../types";
import axios from "axios";
import {
  NonZeroBalanceLedger,
  NonZeroLedgerBalanceInfo_NY,
  NonZeroLedgerBase
} from "../../nonZeroBalanceLedgers/types";

export const getNonZeroLedgerBalancesUniqueAssignedToList = (
  nonZeroLedgerBalances: NonZeroLedgerBase[]
): MemberTaskCount[] => countAndMapAssignedTasks(nonZeroLedgerBalances, "Non Zero Ledger Balances");

export const NY_searchNonZeroLedgerBalances = async (): Promise<NonZeroLedgerBalanceInfo_NY[]> => {
  const { data } = await axios.get<NonZeroLedgerBalanceInfo_NY[]>(`/api/outstandingchecks/getNonZeroLedgerBalance`);
  return data;
};

export const searchNonZeroLedgerBalances = async (): Promise<NonZeroBalanceLedger[]> => {
  const { data } = await axios.get<NonZeroBalanceLedger[]>(`/api/ledgers/GetNonZeroBalanceLedgers`);
  return data;
};

export const searchEarnestDepositLedgers = async (): Promise<NonZeroBalanceLedger[]> => {
  const { data } = await axios.get<NonZeroBalanceLedger[]>(`/api/ledgers/GetEarnestDepositLedgers`);
  return data;
};

export const getLedgerInfo = async (orderNumber: string): Promise<NonZeroBalanceLedger> => {
  const { data } = await axios.get<NonZeroBalanceLedger>(`/api/ledgers/getledgerinfo?ordernumber=${orderNumber}`);
  return data;
};
